module.exports = __webpack_public_path__ + "static/media/video.16fa1ffc.mp4";